import axios from 'axios'
import moment from 'moment'
import { notification } from '@/helpers/notification'
import useFormattedData from '@/composables/useFormattedData'

export const EventMixin = {
    props: {
        getStartedStep: {
            type: Number
        },
        eventId: {
            type: Number
        },
        inviteEmail: {
            type: Object | null
        },
        profileSelectedDate: {
            type: String | null
        },
        profileEmail: {
            type: Object | null
        },
        booker: {
            type: Object,
            required: true
        }
    },
    emits: ['update:profileSelectedDate', 'update:profileEmail', 'steps-mobile'],
    data: () => ({
        promoter: true,
        artistEvents: [],
        selectedVenue: null,
        artistInvited: null,
        selectedDates: '',
        modalMode: '',
        events: [],
        opportunityType: false,
        slug: '',
        eventData: null,
        mode: 'createEvent',
        modalStep: 1,
        transformedEvents: [],
        transformedEventsForBudget: [],
        filterStatus: null,
        dataLoaded: false,
        radioValue: false,
        relevantArtistData: [],
        selectedArtistIndex: [],
        artistsData: '',
        inviteSpecialArtist: [],
        relevantArtistsEmail: [],
        minValue: 50,
        maxValue: 500,
        selectedDataLine: '',
        values: [],
        maxSliderValue: null,
        relevantArtistsCount: [],
        emailInvalid: false,
        eventDate: '',
        eventVibe: '',
        eventBudget: '',
        eventTags: '',
        showEventMenu: false,
        eventCancelNotification: false,
        eventDeleteNotification: false,
        eventId: '',
        approvedArtists: [],
        respondedArtists: [],
        locateTags: [],
        editEventData: false,
        eventStartTimeValue: '',
        stepsMobile: false,
        venueContacts: [],
        contactSelected: false,
        opportunityDetail: '',
        hidePayout: false,
        privateOpportunity: false,
        showContacts: false,
        disableCreateEventBtn: false,
        creatingEvent: false,
        eventCardStyles: {
            container: {
                gap: '25px'
            },
            card: {
                'min-height': '333px'
            },
            title: {
                'margin-top': '6px'
            },
            info: {
                'margin-top': '8px'
            },
            image: {
                width: '320px'
            }
        },

        subscriptionPlan: '',
        subscriptionMode: false,
        currentPage: 1,
        perPage: 15,
        selectedCount: null,
        filter: [
            {
                filterStatus: null,
                id: 'filterAll',
                label: 'All'
            },
            {
                filterStatus: 1,
                id: 'Book',
                label: 'Book'
            },
            {
                filterStatus: 2,
                id: 'Advance',
                label: 'Advance'
            },
            {
                filterStatus: 3,
                id: 'Wrap Up',
                label: 'Wrap Up'
            },
            {
                filterStatus: 5,
                id: 'Cancel',
                label: 'Cancelled'
            },
            {
                filterStatus: 4,
                id: 'Completed',
                label: 'Completed'
            }
        ],
        optionList: false,
        selectedValue: 'All'
    }),
    methods: {
        initBookingFlowFromArtistPage() {
            const domain = this.getDomain(window.location.href)
            if (
                window.location.href.includes('#referred-by-artist-profile') &&
                window.document.referrer.includes(`${domain}/artists/`) &&
                this.profileSelectedDate &&
                this.profileEmail
            ) {
                this.selectedDates = this.profileSelectedDate
                this.inviteSpecialArtist.push(this.profileEmail)
                this.mode = 'addTagsStep'
                this.$emit('update:profileSelectedDate', null)
                this.$emit('update:profileEmail', null)
                this.modalStep = 2
                this.checkAvails()
            } else if (
                ((window.location.href.includes('#referred-by-artist-profile') &&
                    window.document.referrer.includes(`${domain}/artists/`)) ||
                    window.location.href.includes('#referred-from-artists-page') ||
                    (window.location.href.includes('#referred-by-venue-completed-event') &&
                        window.document.referrer.includes(`${domain}/booking-manager/completed-history/`))) &&
                this.inviteEmail
            ) {
                this.checkAvails()
            }
        },
        selectOption(status) {
            this.filterStatus = status.filterStatus
            this.selectedValue = status.label
            this.optionList = false
        },
        toggleOption() {
            this.optionList = !this.optionList
        },
        handleTotalCount(data) {
            this.selectedCount = data
        },
        goToSubscription() {
            window.location.href = '/profile/stripe/plans/venue'
        },
        handlePageChange(page) {
            this.currentPage = page
        },
        getRelevantArtistsCount() {
            this.relevantArtistsCount = this.relevantArtistsEmail.map((artist) => artist.relevantArtistsList)
        },
        handleContactClick(contact) {
            if (contact.selected) {
                contact.selected = false
                const indexToDel = this.relevantArtistsEmail.indexOf(contact.band_email)

                this.relevantArtistsEmail.splice(indexToDel, 1)
            } else {
                this.$set(contact, 'selected', true)
                this.$set(contact, 'email', contact.band_email)

                this.relevantArtistsEmail.push({ relevantArtistsList: [contact] })
            }
            this.getRelevantArtistsCount()
        },
        selectIndividualContact(email) {
            const contact = this.venueContacts.find((c) => c.band_email === email)

            this.setContactsDropdown(false)
            if (contact) this.handleContactClick(contact)
        },
        handleSelectAllContacts() {
            this.contactSelected = !this.contactSelected
            this.venueContacts.forEach((contact) => this.handleContactClick(contact))
        },
        setContactsDropdown(state) {
            this.showContacts = state
        },
        setPrivateOpportunity() {
            this.privateOpportunity = true
        },
        setPublicOpportunity() {
            this.privateOpportunity = false
        },
        showPayoutInput() {
            this.hidePayout = false
        },
        hidePayoutInput() {
            this.hidePayout = true
        },
        goBackStep() {
            switch (this.modalStep) {
                case 1:
                    this.closeModal()
                    break
                case 2:
                    {
                        if (this.promoter) {
                            this.modalStep = 6
                        } else {
                            this.modalStep = 1
                        }
                    }
                    break

                case 6:
                    this.modalStep = 1
                    break
                case 3:
                    this.mode = 'addTagsStep'
                    this.modalStep = 2
                    break
                case 4:
                    this.modalStep = 3
                    break
            }
        },
        getInvitedArtistFromStorage() {
            this.$nextTick(() => {
                if (this.inviteEmail?.email) this.inviteSpecialArtist.push(this.inviteEmail)
            })
        },
        setAllVibes() {
            this.$refs.eventTagsModal.addAllTags()
            this.mode = 'budgetStep'
            this.modalStep = 3
        },
        cardTextAplly(number) {
            let text = number > 1 ? 'artists have' : 'artist has'
            return `${number} ${text} applied:`
        },
        artistAppliedText(number) {
            return number > 1 ? 'artists' : 'artist'
        },
        closeMobileSteps() {
            this.resetCreateEventModal()
            this.resetEventStates()
            this.stepsMobile = false
        },
        resetCreateEventModal() {
            this.modalStep = 1
            this.selectedDates = null
            this.selectedCount = 0
            this.eventTags = []
            this.locateTags = []
            this.minValue = 50
            this.maxValue = 500
        },
        closeModal() {
            this.resetCreateEventModal()
            this.resetEventStates()
            this.$bvModal.hide('modal-create-event')
        },
        handleEsc(event) {
            if (event.key === 'Escape') {
                this.resetCreateEventModal()
                this.$bvModal.hide('modal-create-event')
            }
        },
        openCancelEventModal(eventId) {
            this.eventId = eventId
            this.$bvModal.show('modal-cancel-event-venue')
        },
        openDeleteEventModal(eventId) {
            this.eventId = eventId
            this.$bvModal.show('modal-delete-event-venue')
        },
        async deleteEvent() {
            try {
                await axios.delete('/api/event/manage/' + this.eventId + '/delete')
                this.$bvModal.hide('modal-delete-event-venue')
                this.eventDeleteNotification = true
                const eventIndex = this.events.findIndex((event) => event.id === this.eventId)
                this.events.splice(eventIndex, 1)
                setTimeout(() => {
                    this.eventDeleteNotification = false
                }, 5000)
            } catch (error) {
                notification('error', error)
            }
        },
        async cancelEvent() {
            try {
                await axios.put('/event/manage/' + this.eventId + '/cancel')
                this.$bvModal.hide('modal-cancel-event-venue')
                const eventIndex = this.events.findIndex((event) => event.id === this.eventId)
                this.events.splice(eventIndex, 1)
                this.eventCancelNotification = true
                setTimeout(() => {
                    this.eventCancelNotification = false
                }, 5000)
            } catch (error) {
                notification('error', error)
            }
        },
        toggleSelection(index, artist, location) {
            if (this.selectedArtistIndex.includes(index)) {
                const index = this.selectedArtistIndex.indexOf(index)
                this.selectedArtistIndex.splice(index, 1)
                const indexRelevantArtist = this.relevantArtistsEmail.indexOf(location)
                this.relevantArtistsEmail.splice(indexRelevantArtist, 1)
                this.relevantArtistsCount = this.relevantArtistsEmail.map((artist) => artist.relevantArtistsList)
            } else {
                this.selectedArtistIndex.push(index)
                this.relevantArtistsEmail.push(artist)
                this.relevantArtistsCount = this.relevantArtistsEmail.map((artist) => artist.relevantArtistsList)
            }
        },
        /**
         * @TODO make this more consistent and more readable
         *
         */
        async getAllEvents() {
            const data = await axios.get(`/api/events/manage/booking-manager/events/all/${this.booker.id}`)

            this.events = data.data.created_events.concat(data.data.venue_events)
            this.artistEvents = data.data.applied_events.concat(data.data.invited_events)
            this.subscriptionPlan = data.data.subscription ?? ''
            this.opportunityType = true
        },
        getIcon() {
            return '/images/'
        },
        addTitle() {
            this.modalMode = 'addTitle'
            this.$bvModal.show('edit-event-modal')
        },
        addTime(event) {
            if (event.status < 3) {
                this.eventData = event
                this.modalMode = 'addTime'
                this.$bvModal.show('edit-event-modal')
            }
        },
        addTags(event) {
            if (event.status < 3) {
                this.eventData = event
                this.modalMode = 'addTags'
                this.$bvModal.show('edit-event-modal')
            }
        },
        addDate(id) {
            this.eventId = id
            this.modalMode = 'addDate'
            this.$bvModal.show('edit-event-modal')
        },
        addImage() {
            this.modalMode = 'addImage'
            this.$bvModal.show('edit-event-modal')
        },
        createEvent() {
            this.$refs.calendarForm.eventsDate()
            if (!this.selectedDates) return
            this.mode = 'addTagsStep'
            if (this.promoter) {
                this.modalStep = 6
            } else {
                this.modalStep = 2
            }
        },
        nextModalStep() {
            this.$refs.eventTagsModal.createEventsTag()
            if (this.eventTags.length) {
                this.mode = 'budgetStep'
                this.modalStep = 3
            } else {
                this.mode = 'addTagsStep'
                this.modalStep = 2
            }
        },
        handleSelectedVenue(venue) {
            this.selectedVenue = venue
        },
        goToBudgetStep() {
            if (!this.eventTags.length) {
                this.setAllVibes()
            } else {
                this.nextModalStep()
            }
        },
        async budgetModalStep() {
            this.eventId = ''
            const response = await axios.post('/api/booking-manager/relevant-artists', {
                keywords: this.eventTags ? this.eventTags.join(', ') : this.eventVibe.join(', '),
                is_need_all: this.eventTags.length === 1 && this.eventTags[0] === 'All Genres'
            })
            this.relevantArtistData = response.data.artists.splitByLocation
            this.venueContacts = response.data.artists.contacts
            this.modalStep = 4
        },
        async finalModalStep() {
            this.disabledBtn = true
            let response = ''
            try {
                if (this.editEventData) {
                    response = await axios.put('/api/event/manage/update/' + this.eventId, {
                        start_time: this.eventStartTimeValue,
                        private_opportunity: this.privateOpportunity
                    })
                } else {
                    response = await axios.post(`/api/event/manage/create-event/${this.booker.id}`, {
                        keyword: this.eventTags,
                        duration: 4,
                        start: this.selectedDates,
                        status: 1,
                        budget: this.eventBudget,
                        opportunity_detail: this.opportunityDetail,
                        private_opportunity: this.privateOpportunity,
                        venue_name: this.selectedVenue?.venue_name ?? null,
                        address: this.selectedVenue?.address ?? null,
                        latitude: this.selectedVenue?.lat ?? null,
                        longitude: this.selectedVenue?.lon ?? null
                    })
                }
                if (this.getEventsCounter === 1) {
                    const newEvent = {
                        ...response.data.events[0],
                        event_name: '',
                        status: 1,
                        responded_artist: [],
                        approved_artists: [],
                        imported_event_artists: [],
                        new: true
                    }
                    this.setNewEvent(newEvent)
                    if (!this.editEventData) this.getEventForDays()
                } else {
                    if (!this.editEventData) {
                        const newEvents = response.data.events
                        newEvents.forEach((e) => {
                            this.setNewEvent({
                                ...e,
                                new: true,
                                status: 1,
                                responded_artist: [],
                                approved_artists: [],
                                imported_event_artists: []
                            })
                            e.new = true
                        })
                        this.getEventForDays()
                    }
                }
                this.modalStep = 5
                notification('success', response.data.message)
            } catch (error) {
                notification('error', error)
            } finally {
                this.disabledBtn = false
                this.editEventData = false
            }
        },
        getEventForDays() {
            const eventsByDate = {}
            this.events.forEach((event) => {
                if (event.start !== undefined) {
                    const date = new Date(event.start).toISOString().split('T')[0]
                    if (!eventsByDate[date]) {
                        eventsByDate[date] = []
                    }
                    eventsByDate[date].push({ ...event, index: eventsByDate[date].length })
                }
            })
            this.getEventForCalendar(eventsByDate)
        },
        getEventForCalendar(eventsByDate) {
            this.events.forEach((event) => {
                if (event.start !== undefined && !this.transformedEvents.find((e) => e.eventId === event.id)) {
                    const date = new Date(event.start).toISOString().split('T')[0]
                    const eventsForDate = eventsByDate[date]
                    const index = eventsForDate.findIndex((e) => e.id === event.id)
                    const eventForCalendar = {
                        title: this.getTitleEvent(event.status),
                        start: event.start,
                        startDate: this.getEventStartDate(event.start),
                        startTime: event.start_time,
                        color: this.getColorEvent(event.status),
                        url: '/event/manage/' + event.id + '/edit',
                        id: eventsForDate[index].index,
                        eventId: event.id,
                        maxBudget: event.max,
                        minBudget: event.min,
                        counter: event?.my_artist_bid?.counter_offer,
                        vibe: event.array_keywords,
                        budget: event.budget,
                        status: event.status,
                        total_payout: event.total_payout,
                        privateOpportunity: event.private_opportunity
                    }
                    this.transformedEvents.push(eventForCalendar)
                }
            })
        },
        async goToSearchResult(relevantArtistsList) {
            try {
                await axios.post('/api/booking-manager/relevant-artists-list', {
                    relevantArtists: relevantArtistsList
                })
                localStorage.setItem('relevantArtistsList', JSON.stringify(relevantArtistsList))
                window.open('/booking-manager/artists-list', '_blank')
            } catch (error) {
                notification('error', error.response.data.errors.message)
            }
        },
        editEvent(id) {
            window.location.href = '/event/manage/' + id + '/edit'
        },
        getEventForBudget() {
            this.transformedEventsForBudget = this.events.map((event) => event.total_payout)
        },
        getColorEvent(status) {
            if (status === 1) {
                return '#C9CD00'
            } else if (status === 2) {
                return '#CB9B1F'
            } else if (status === 3) {
                return '#D188BF'
            } else if (status === 5) {
                return '#646464'
            } else if (status === 4) {
                return '#BA87FF'
            } else if (status === 0) {
                return '#acacac'
            }
        },
        getEventStartDate(start) {
            if (!start) return undefined

            const startDate = start.split(' ')[0]
            const startDateSplit = startDate.split('-')
            const year = startDateSplit[0]
            const month = startDateSplit[1]
            const date = startDateSplit[2]

            if (start.includes('T')) {
                return moment.utc(start).local().format('MMMM DD YYYY')
            } else {
                return `${month}-${date}-${year}`
            }
        },
        getTitleEvent(status) {
            if (status === 1) {
                return 'Book'
            } else if (status === 2) {
                return 'Advance'
            } else if (status === 3) {
                return 'WrapUp'
            } else if (status === 5) {
                return 'Cancelled'
            } else if (status === 4) {
                return 'Completed'
            } else if (status === 0) {
                return 'Avails Checked'
            } else if (status === 6) {
                return 'Rejected'
            }
        },
        backToTagsStep() {
            this.locateTags = this.eventTags
            this.modalStep = 2
            this.mode = 'addTagsStep'
        },
        showModal() {
            if (this.width > 1000) {
                if (this.promoter) {
                    this.modalStep = 6
                } else {
                    this.modalStep = 2
                }
                this.mode = 'addTagsStep'
                this.$refs.openModal.click()
            } else {
                this.mode = 'addTagsStep'
                this.$emit('steps-mobile', true)
                if (this.promoter) {
                    this.modalStep = 6
                } else {
                    this.modalStep = 2
                }
            }
        },
        onCardCtaClicked(event) {
            this.goToEventByStatusPage(event)
        },
        goToEventByStatusPage(event) {
            localStorage.clear()
            localStorage.setItem('eventId', event.id)
            if (event.status === 1) {
                window.location.href = `/event/book-artist/${event.id}/${event.venue_id}`
            } else if (event.status === 2) {
                window.location.href = `/event/advance-book-artist/${event.id}/${event.venue_id}`
            } else if (event.status === 3) {
                window.location.href = `/event/wrap-up-artist`
            } else if (event.status === 4) {
                window.location.href = `/booking-manager/completed-history/${event.id}`
            } else {
                return
            }
        },
        async openCheckAvailsModal(date, vibe, budget, id, start_time, privateOpportunity) {
            if (this.width > 1000) {
                this.eventStartTimeValue = start_time
                this.editEventData = true
                this.eventBudget = budget
                this.selectedDates = date
                this.eventTags = vibe
                this.privateOpportunity = privateOpportunity
                await this.budgetModalStep()
                this.eventId = id
                this.$refs.openModal.click()
            } else {
                this.eventStartTimeValue = start_time
                this.editEventData = true
                this.eventBudget = budget
                this.selectedDates = date
                this.eventTags = vibe
                this.privateOpportunity = privateOpportunity
                await this.budgetModalStep()
                this.eventId = id
                this.$emit('steps-mobile', true)
            }
        },
        updateEventData(data) {
            if (data) {
                const event = this.events.find((event) => event.id === data.id)
                if (data.start) event.start = data.start
                if (data.start_date) event.start_date = data.start_date
                if (data.budget) event.budget = data.budget
                if (data.opportunity_detail) event.opportunity_detail = data.opportunity_detail
                if (data.start_time) event.start_time = data.start_time
                if (data.duration) event.duration = data.duration
                if (data.recurring) event.recurring = data.recurring
                if (data.event_name) event.event_name = data.event_name
                if (data.keywords) event.array_keywords = data.keywords.split(', ')
                if (data.image) event.image = data.image
                if (data.description) event.description = data.description
                if (data.cover_cost) event.cover_cost = data.cover_cost
                if (data.min_age) event.min_age = data.min_age

                this.editEventData = false
                this.$bvModal.hide('edit-event-modal')
                this.transformedEvents.splice(0)
                this.getEventForDays()
            } else {
                return
            }
        },
        setNewEvent(data) {
            if (!this.events.find((e) => e.id === data.id)) {
                this.events = [...this.events, data]
                this.transformedEvents = []
                this.getEventForDays()
            }
        },
        validateEmail(email) {
            const regEx = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            return regEx.test(email)
        },
        validateEmailsArray() {
            const emailsArray = this.artistsData.split(/[,;]/)
            if (emailsArray.length >= 2) {
                return emailsArray.every((email) => {
                    return this.validateEmail(email.trim())
                })
            } else {
                this.emailInvalid = true
                return this.validateEmail(this.artistsData)
            }
        },
        addArtists() {
            const isValid = this.validateEmailsArray()
            if (isValid) {
                this.emailInvalid = false
                if (this.inviteSpecialArtist.length) {
                    let artistsArray = this.artistsData.split(/[,;]/).map((v) => ({ email: v.trim() }))
                    this.inviteSpecialArtist = this.inviteSpecialArtist.concat(artistsArray)
                    this.artistsData = ''
                } else {
                    this.inviteSpecialArtist = this.artistsData.split(/[,;]/).map((v) => ({ email: v.trim() }))

                    this.artistsData = ''
                }
            } else {
                this.emailInvalid = true
            }
        },
        resetEventStates() {
            this.opportunityDetail = ''
            this.eventBudget = ''
            this.privateOpportunity = false
            this.hidePayout = false
            this.inviteSpecialArtist = []
            this.selectedVenue = null
            if (this.contactSelected) this.handleSelectAllContacts()
        },
        async inviteArtist() {
            this.disabledBtn = true
            try {
                this.creatingEvent = true
                const response = await axios.post(`/api/booking-manager/invite-artists/${this.booker.id}`, {
                    keyword: this.eventTags.length ? this.eventTags : this.eventVibe,
                    additional_recipients: this.inviteSpecialArtist.map((v) => v.email).join(', '),
                    start:
                        this.selectedDates && this.selectedDates.length
                            ? this.selectedDates
                            : this.eventDate.replace(',', ''),
                    duration: 4,
                    relevant_artist: [...new Set(this.getInvitedArtistsEmail)],
                    budget: this.eventBudget,
                    opportunity_detail: this.opportunityDetail,
                    private_opportunity: this.privateOpportunity,
                    event_id: this.eventId,

                    venue_name: this.selectedVenue?.venue_name ?? null,
                    address: this.selectedVenue?.address ?? null,
                    latitude: this.selectedVenue?.lat ?? null,
                    longitude: this.selectedVenue?.lon ?? null
                })
                if (this.getEventsCounter === 1) {
                    const newEvent = {
                        ...response.data.events[0],
                        event_name: '',
                        status: 1,
                        responded_artist: [],
                        approved_artists: [],
                        imported_event_artists: [],
                        new: true
                    }
                    this.setNewEvent(newEvent)
                    if (!this.editEventData) this.getEventForDays()
                } else {
                    if (!this.editEventData) {
                        const newEvents = response.data.events
                        newEvents.forEach((e) => {
                            this.setNewEvent({
                                ...e,
                                new: true,
                                status: 1,
                                responded_artist: [],
                                approved_artists: [],
                                imported_event_artists: []
                            })
                            e.new = true
                        })
                        this.getEventForDays()
                    }
                }
                this.modalStep = 5
                notification('success', response.data.message)
            } catch (error) {
                notification('error', error)
            } finally {
                this.disabledBtn = false
                this.editEventData = false
                this.creatingEvent = false
            }
        },

        handleFormattedDate(date) {
            this.selectedDates = date
        },
        selectedChartData(ctx, value, rangeMin, rangeMax) {
            const label = this.chartLineBar.labels[value + 1]
            if (label >= parseInt(rangeMin) && label <= parseInt(rangeMax)) {
                return '#97ad0c'
            } else {
                return 'rgba(0, 0, 0, 0)'
            }
        },
        handleFilterEventsFromCal(status) {
            this.filterStatus = status
        },
        handleUpdateSelectedDates(dates) {
            this.selectedDates = dates
        },
        handleCopyEventLink() {
            let hostname = window.location.hostname
            if (hostname === 'localhost') {
                navigator.clipboard.writeText(
                    `${window.location.protocol}//${window.location.hostname}:${window.location.port}/event/show/${this.eventId}`
                )
            } else {
                navigator.clipboard.writeText(
                    `${window.location.protocol}//${window.location.hostname}/event/show/${this.eventId}`
                )
            }
        },
        getDomain(url) {
            let domain = new URL(url).host
            if (url.includes('https')) {
                return `https://${domain}`
            } else {
                return `http://${domain}`
            }
        },
        removeEmail(index) {
            this.getInvitedArtist.splice(index, 1)
        },
        showAvailsChecked(event) {
            if (this.width < 1000) {
                return event.status === 0
            }
            return true
        },
        showBookArtist(event) {
            if (this.width < 1000) {
                return event.status === 1 || event.status === 2
            }
            return true
        },
        showAdvance(event) {
            if (this.width < 1000) {
                return event.status === 1 || event.status === 2 || event.status === 3
            }
            return true
        },
        showWrapUp(event) {
            if (this.width < 1000) {
                return event.status === 3
            }
            return true
        },
        getMobileColor(event) {
            if (event.status === 0 && this.width < 600) return '#cdeb09'
            if (event.status === 1 && this.width < 600) return '#c9cd00'
            if (event.status === 2 && this.width < 600) return '#cb9b1f'
            if (event.status === 3 && this.width < 600) return '#d188bf'
        },
        inviteTextInfo(events) {
            let artistString = ''
            let eventsString = ''
            this.artistInvited > 1 ? (artistString = 'artists') : (artistString = 'artist')
            events > 1 ? (eventsString = 'events') : (eventsString = 'event')

            const { formatNumberToEnglish } = useFormattedData()

            return this.artistInvited !== null && this.artistInvited > 0
                ? `You’ve created
                    ${formatNumberToEnglish(events)} new  ${eventsString} and invited ${
                      this.artistInvited
                  } ${artistString} to apply.`
                : `You’ve created ${formatNumberToEnglish(events)} new  ${eventsString}.`
        },
        /**
         * @TODO make this more consistent and more readable
         *
         */
        checkAvails() {
            if (
                (this.subscriptionPlan === 'VenueFree' || this.subscriptionPlan === 'ArtistFree') &&
                this.actualEventNumber >= 5
            ) {
                this.showSubscriptionWarningModal()
            } else if (
                (this.subscriptionPlan === 'VenuePro' || this.subscriptionPlan === 'ArtistPro') &&
                this.actualEventNumber >= 10
            ) {
                this.showSubscriptionWarningModal()
            } else if (this.subscriptionPlan === 'VenueGrowth' && this.actualEventNumber >= 20) {
                this.showSubscriptionWarningModal()
            } else {
                if (this.width > 600) {
                    this.$bvModal.show('modal-create-event')
                } else {
                    this.$emit('steps-mobile', true)
                }
            }
        },
        showSubscriptionWarningModal() {
            if (this.modalStep <= 2) {
                this.subscriptionMode = true
                this.$bvModal.show('modal-cancel-event-venue')
            } else {
                this.$bvModal.show('modal-create-event')
            }
        },

        switchEventCount(status) {
            let countEvent
            switch (status) {
                case null:
                    countEvent = this.events
                    break
                default:
                    countEvent = this.events.filter((event) => event.status === status)
                    break
            }
            if (countEvent.length === 0) return 'No events'
            else if (countEvent.length === 1) return `${countEvent.length} Event`
            else return `${countEvent.length} Events`
        },
        changeStatusFilter(status) {
            this.handlePageChange(1)
            this.filterStatus = status.filterStatus
        }
    },
    computed: {
        totalPages() {
            return Math.ceil(this.getEvents.length / this.perPage)
        },
        actualEventNumber() {
            const today = moment()
            const venueEvents = this.events.filter((event) => {
                const testDate = new Date(event.start_date)
                const eventDate = isNaN(testDate) ? moment(event.start_date, 'ddd, MMMM Do') : moment(event.start_date)
                return eventDate.isAfter(today, 'day') && event.status !== 5
            })
            return venueEvents.length
        },
        formattedSelectedDates() {
            if (!this.selectedDates || (this.selectedDates && this.selectedDates.length === 0)) return []

            const formattedDates = []
            const selectedDates = this.selectedDates.split(', ')

            selectedDates.forEach((date) => {
                const dateArr = date.split(' ')
                const month = dateArr[0]
                const day = dateArr[1]
                const year = dateArr[2]

                formattedDates.push(`${month} ${day.slice(0, -2)} ${year}`)
            })

            return formattedDates
        },
        disableBtn() {
            switch (this.subscriptionPlan) {
                case 'VenueFree':
                case 'ArtistFree':
                    return this.actualEventNumber + this.selectedCount > 5
                case 'VenuePro':
                    return this.actualEventNumber + this.selectedCount > 10
                case 'VenueGrowth':
                    return this.actualEventNumber + this.selectedCount > 20
                case 'VenuePremium':
                    return false
                default:
                    return false
            }
        },
        dateLanguage: (self) =>
            self.selectedDatesFormatted(self.selectedDates).split(',').length === 1 ? 'Date: ' : 'Dates: ',
        invitationLanguage: (self) => {
            const totalArtists = [
                ...new Set(self.inviteSpecialArtist.map((a) => a.email).concat(self.getInvitedArtistsEmail))
            ].length
            self.artistInvited = totalArtists

            let invitation = 'Invitation'
            let artist = 'Artist'

            if (totalArtists > 1) {
                invitation = invitation + 's'
                artist = artist + 's'
            }

            if (self.creatingEvent) {
                return 'Sending Invitations...'
            }
            return `Send ${invitation} To ${totalArtists} ${artist}`
        },
        opportunityDetailWordCount: (self) => `${self.opportunityDetail.length} / 500`,
        selectedDatesFormatted: () => (dates) => {
            if (!dates) return ''

            const datesArr = dates.split(', ')
            if (datesArr.length > 1) {
                const datesFormatted = datesArr.map((date) => {
                    const dateSplit = date.split(' ')
                    const month = dateSplit[0]
                    const day = dateSplit[1]

                    return `${month} ${day}`
                })
                return datesFormatted.join(', ')
            } else {
                if (dates.includes('-')) {
                    return moment(dates).format('MMM Do')
                } else {
                    const dateSplit = dates.split(' ')
                    const month = dateSplit[0]
                    const day = dateSplit[1]

                    return `${month} ${day}`
                }
            }
        },
        paginatedArtists() {
            const startIndex = (this.currentPage - 1) * this.perPage
            const endIndex = startIndex + this.perPage

            if (endIndex > this.getEvents.length) {
                return this.getEvents.slice(startIndex)
            }

            return this.getEvents.slice(startIndex, endIndex)
        },
        getLengthArtists() {
            return this.getEvents.length
        },
        getDisabledClass() {
            return this.eventTags.length === 0
        },
        getAllRelevantArtists() {
            return this.relevantArtistsCount.length
        },
        getEventsCounter() {
            let eventCounter = this.selectedDates.split(', ')
            return eventCounter.length
        },
        getAllCalendarEvents: {
            get() {
                return this.transformedEvents
            },
            set(events) {
                this.transformedEvents = events
            }
        },
        getInvitedArtistsEmail() {
            let result = this.relevantArtistsEmail.map((artistInfo) => {
                if (artistInfo.relevantArtistsList) {
                    return artistInfo.relevantArtistsList.map((artist) => artist.email)
                }
            })
            return result.flat()
        },
        chartLineBar() {
            let eventsCopy = [...this.events]
            let filteredEvents = eventsCopy.sort((a, b) => a.budget - b.budget)
            let counts = filteredEvents.reduce((acc, obj) => {
                let budget = obj.budget
                acc[budget] = (acc[budget] || 0) + 1
                return acc
            }, {})

            let filteredData = Object.values(counts)
            let unicChartData = [...new Set(filteredData)]
            unicChartData.push(0)
            unicChartData.unshift(0)
            const filteredDataLabel = this.transformedEventsForBudget.filter((value) => value !== 0)
            let unicLabel = [...new Set(filteredDataLabel)]
            unicLabel.unshift(50)
            unicLabel.sort((a, b) => a - b)
            let price = [3000, 0]
            let labels = [unicLabel, ...price].flat()
            return {
                labels: labels,
                datasets: [
                    {
                        data: unicChartData,
                        borderColor: '#ACACAC',
                        fill: true,
                        tension: 0.4,
                        pointRadius: 0,
                        borderWidth: 1,
                        segment: {
                            backgroundColor: this.segmentBackgroundColor
                        }
                    }
                ]
            }
        },
        segmentBackgroundColor() {
            let min
            let max
            if (!this.budgetMode) {
                min = this.minValue
                max = this.maxValue
            } else {
                min = this.budgetMinValue
                max = this.budgetMaxValue
            }
            return (ctx) => this.selectedChartData(ctx, ctx.p0DataIndex, min, max)
        },
        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        display: false
                    },
                    y: {
                        display: false
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    }
                }
            }
        },
        getEvents() {
            if (this.filterStatus === null) {
                let events = this.filterEvents(this.events)
                return events
            } else {
                return this.events.filter((event) => event.status === this.filterStatus)
            }
        },
        getTags() {
            if (this.eventTags) {
                return this.eventTags.join(', ')
            } else {
                return this.eventTags
            }
        },
        getInvitedArtist() {
            return this.inviteSpecialArtist
        },
        eventStartTime: () => (event) => {
            if (event.new && (!event.start_time || event.start_time.includes('12:00 AM'))) {
                return 'Add Time'
            }
            const { formatTimeString } = useFormattedData()

            return formatTimeString(event.start_time, { duration: event.duration })
        }
    },
    watch: {
        minValue(newValue) {
            this.values = [newValue, this.maxValue]
        },
        maxValue(newValue) {
            this.values = [this.minValue, newValue]
        },
        hidePayout(hide) {
            if (hide) this.eventBudget = ''
        },
        getStartedStep: {
            handler: function (step) {
                if (step === 1) {
                    this.checkAvails()
                }
            },
            immediate: true
        },
        filterStatus: function () {
            this.currentPage = 1
        },
        inviteEmail: {
            handler: function(contactObj) {
                if (Object.values(contactObj).some((val) => !!val)) {
                    this.initBookingFlowFromArtistPage()
                }
            }
        }
    },
    async created() {
        await this.getAllEvents()
        this.getEventForDays()
        this.getEventForBudget()
        this.dataLoaded = true
        this.maxSliderValue = Math.max(...this.transformedEventsForBudget)
        this.values = [this.minValue, this.maxValue]
    },
    mounted() {
        this.getInvitedArtistFromStorage()
        let domain = this.getDomain(window.location.href)

        document.addEventListener('keydown', this.handleEsc)

        if (
            (window.location.href === `${domain}/booking-manager#referred-by-marketing` &&
                window.document.referrer === `${domain}/for-bookers`) ||
            (window.location.href.includes('#referred-by-contacts') &&
                window.document.referrer.includes(`${domain}/profile/contacts`))
        ) {
            this.checkAvails()
        }
    },
    beforeDestroy() {
        localStorage.clear()
        document.removeEventListener('keydown', this.handleEsc)
        this.editEventData = false
    }
}
